// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-area {
  position: relative;
  z-index: var(--z-index-local-default);
  box-sizing: border-box;
  display: inline-block;
  width: 100%;
  color: var(--font_active_color);
  background-color: var(--input-bg-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  width: 100%;
}
.select-area.disabled {
  background-color: var(--disabled-bg-color);
  border: 1px solid var(--disabled-border-color);
  color: var(--disabled-font-color);
}
.select-area.disabled .select-box:disabled {
  color: var(--disabled-font-color);
  cursor: default;
}
.select-area .select-box {
  position: relative;
  z-index: var(--z-index-local-over-1);
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 0 40px 0 12px;
  color: var(--font_active_color);
  font-size: 14px;
  cursor: pointer;
  background: 0 0;
  border: none;
  outline: 0;
  appearance: none;
}
.select-area .select-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  right: 12px;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Select.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qCAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,+BAAA;EAEA,uCAAA;EACA,qCAAA;EACA,kBAAA;EAEA,WAAA;AADF;AAKE;EACE,0CAAA;EACA,8CAAA;EACA,iCAAA;AAHJ;AAKI;EACE,iCAAA;EACA,eAAA;AAHN;AAOE;EACE,kBAAA;EACA,oCAAA;EACA,sBAAA;EAEA,WAAA;EACA,YAAA;EACA,sBAAA;EAGA,+BAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EAEA,gBAAA;AARJ;AAWE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;AATJ","sourcesContent":[".select-area {\r\n  position: relative;\r\n  z-index: var(--z-index-local-default);\r\n  box-sizing: border-box;\r\n  display: inline-block;\r\n  width: 100%;\r\n  color: var(--font_active_color);\r\n\r\n  background-color: var(--input-bg-color);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n\r\n  width: 100%;\r\n\r\n  // 変更できない項目はTextInputの:disabledと同じ見た目にする(基本情報ページと揃える)\r\n  // selectの背景と枠線は.select-area側が持っているため、こちらで上書きする\r\n  &.disabled {\r\n    background-color: var(--disabled-bg-color);\r\n    border: 1px solid var(--disabled-border-color);\r\n    color: var(--disabled-font-color);\r\n\r\n    .select-box:disabled {\r\n      color: var(--disabled-font-color);\r\n      cursor: default;\r\n    }\r\n  }\r\n\r\n  .select-box{\r\n    position: relative;\r\n    z-index: var(--z-index-local-over-1);\r\n    box-sizing: border-box;\r\n\r\n    width: 100%;\r\n    height: 40px;\r\n    padding: 0 40px 0 12px;\r\n\r\n    \r\n    color: var(--font_active_color);\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    background: 0 0;\r\n    border: none;\r\n    outline: 0;\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n\r\n  }\r\n  .select-icon{\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    margin: auto 0;\r\n    right: 12px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
